import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import moment from 'moment'

import styles from './PaymentMethodHistoryDialog.module.scss'
import { getActorDisplayName } from './utils'

const PaymentMethodHistoryDialog = ({ error, history, isLoading, onClose }) => (
  <ConfirmationDialog
    title="Payment method history"
    theme="blacklist"
    maxWidth={800}
    onClose={onClose}
    onConfirm={onClose}
  >
    <div className={styles.container}>
      {isLoading && <LoadingIndicator />}
      {!isLoading && error && (
        <p className={styles.message}>Payment method history could not be loaded.</p>
      )}
      {!isLoading && !error && history.length === 0 && (
        <p className={styles.message}>No history found for this payment method.</p>
      )}
      {!isLoading && !error && history.length > 0 && (
        <div className={styles.tableWrapper}>
          <table>
            <thead>
              <tr>
                <th>When</th>
                <th>Action</th>
                <th>Source</th>
                <th>Who</th>
                <th>Note</th>
              </tr>
            </thead>
            <tbody>
              {history.map((entry, index) => (
                <tr key={`${entry.addedOn}-${index}`}>
                  <td>
                    {moment.utc(entry.addedOn).local().format('MMM DD, YYYY h:mm A')}
                  </td>
                  <td>{entry.disableAction}</td>
                  <td>{entry.disableSource}</td>
                  <td>{getActorDisplayName(entry)}</td>
                  <td>{entry.disableNote || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  </ConfirmationDialog>
)

export default PaymentMethodHistoryDialog
